import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconDeleteStudio = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M10.3751 13.5H5.62368C4.87739 13.5 4.3125 12.9281 4.3125 12.2721V5.55518H11.6863V12.2703C11.6863 12.9284 11.1211 13.5 10.3751 13.5Z",
        stroke: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.74952 2.97663L9.49133 2.32103C9.41618 2.12764 9.22929 2 9.02119 2H6.97881C6.77071 2 6.58382 2.12764 6.50674 2.32103L6.24855 2.97663H3V3.97648H13V2.97663H9.74952Z",
        fill: "black"
    }));

export { IconDeleteStudio };
